export const subjectTypeFromGraphql = (subject) => {
  if (!subject) return null;
  if (typeof subject === 'string') return subject;
  return subject.subject || subject.__typename;
};
